import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const reInviteUserContext = React.createContext({});
export let reInviteUserMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMReInviteUser = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  reInviteUserMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(reInviteUserMachine);

  return {
    reInviteUserMachine,
    reInviteUserState: state,
    reInviteUserSend: send,
  };
};
